var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8764 21.0011H19.8764M12.4384 3.26715C12.4816 3.18875 12.545 3.12338 12.622 3.07785C12.6991 3.03232 12.7869 3.0083 12.8764 3.0083C12.9659 3.0083 13.0537 3.03232 13.1308 3.07785C13.2078 3.12338 13.2712 3.18875 13.3144 3.26715L16.2664 8.87115C16.3368 9.00091 16.4351 9.11347 16.5541 9.20076C16.6732 9.28805 16.8101 9.3479 16.955 9.376C17.0999 9.40411 17.2493 9.39978 17.3923 9.36332C17.5354 9.32687 17.6686 9.25919 17.7824 9.16514L22.0594 5.50115C22.1415 5.43437 22.2427 5.39536 22.3484 5.38975C22.454 5.38413 22.5588 5.41219 22.6475 5.46989C22.7362 5.52759 22.8043 5.61195 22.8421 5.71084C22.8798 5.80972 22.8852 5.91802 22.8574 6.02015L20.0234 16.2661C19.9656 16.4758 19.8409 16.6609 19.6684 16.7934C19.4959 16.9258 19.2849 16.9984 19.0674 17.0001H6.6864C6.46874 16.9986 6.25751 16.9261 6.08479 16.7937C5.91207 16.6612 5.7873 16.476 5.7294 16.2661L2.8964 6.02115C2.86865 5.91902 2.87402 5.81072 2.91174 5.71184C2.94946 5.61295 3.01758 5.52859 3.1063 5.47089C3.19502 5.41319 3.29976 5.38513 3.40544 5.39075C3.51112 5.39636 3.6123 5.43537 3.6944 5.50215L7.9704 9.16615C8.0842 9.26019 8.21741 9.32787 8.36046 9.36432C8.50352 9.40078 8.65287 9.40511 8.7978 9.377C8.94273 9.3489 9.07964 9.28905 9.19869 9.20176C9.31775 9.11447 9.416 9.00191 9.4864 8.87215L12.4384 3.26715Z",
    stroke: "#1D5AB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.c934bf1f39b574969e25b43ae50a2528.svg";
export { ForwardRef as ReactComponent };